import _ from "lodash";
import QueryTeams from "graphql/queries/QueryTeams";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchTeam {

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'teams', QueryTeams, {
			variables,
			resultPath: [ 'teams' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						teams: result
					});
				}
			},
		})
	}
}
